// Drifting purple/cyan/coral blob background.
import React from "react";

export default function AnimatedBackground() {
  return (
    <div className="meyecam-blobs" aria-hidden="true">
      <div className="meyecam-blob violet" />
      <div className="meyecam-blob cyan" />
      <div className="meyecam-blob coral" />
    </div>
  );
}
